import { render } from "./StandardHeaderMainNavigationItem.vue?vue&type=template&id=5851c3bb&scoped=true"
import script from "./StandardHeaderMainNavigationItem.vue?vue&type=script&lang=js"
export * from "./StandardHeaderMainNavigationItem.vue?vue&type=script&lang=js"

import "./StandardHeaderMainNavigationItem.vue?vue&type=style&index=0&id=5851c3bb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5851c3bb"]])

export default __exports__